import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe puro — transformação depende apenas do valor de entrada.
 */
@Pipe({
  name: '_normalize',
  pure: true,
})
export class NormalizePipe implements PipeTransform {
  public transform(value: string): string {
    if (!value) {
      return '';
    }
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
}
